import { render } from "./NewsletterSignup.vue?vue&type=template&id=d587fd40&scoped=true"
import script from "./NewsletterSignup.vue?vue&type=script&lang=js"
export * from "./NewsletterSignup.vue?vue&type=script&lang=js"

import "./NewsletterSignup.vue?vue&type=style&index=0&id=d587fd40&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d587fd40"]])

export default __exports__